import { SimulatorWizard } from "@/components/public/SimulatorWizard";
import { COUNTRIES_FR, NATIONALITIES_FR } from "@/lib/geoData";

const steps = [
  {
    title: "Destination & statut",
    description: "Votre situation d'expatriation détermine les contrats éligibles.",
    fields: [
      { name: "pays_residence", label: "Pays de résidence actuel", type: "combo", suggestions: COUNTRIES_FR, required: true, placeholder: "Tapez au moins 3 lettres…" },
      { name: "pays_destination", label: "Pays de destination", type: "combo", suggestions: COUNTRIES_FR, required: true, placeholder: "Tapez au moins 3 lettres…" },
      { name: "date_depart", label: "Date de départ / date d'effet", type: "date", required: true },
      { name: "duree", label: "Durée prévue de l'expatriation", type: "select", required: true, options: [
        { value: "moins_1an", label: "Moins d'un an" }, { value: "1_3ans", label: "1 à 3 ans" },
        { value: "plus_3ans", label: "Plus de 3 ans" }, { value: "indeterminee", label: "Indéterminée" } ] },
      { name: "situation", label: "Situation personnelle / professionnelle", type: "select", options: [
        { value: "salarie_detache", label: "Salarié détaché" }, { value: "salarie_local", label: "Contrat local" },
        { value: "independant", label: "Indépendant / entrepreneur" }, { value: "retraite", label: "Retraité" },
        { value: "etudiant", label: "Étudiant" }, { value: "famille", label: "Famille accompagnante" },
        { value: "sans_profession", label: "Sans profession" } ] },
      { name: "nationalite", label: "Nationalité (si utile à l'éligibilité)", type: "combo", suggestions: NATIONALITIES_FR, placeholder: "Tapez au moins 3 lettres…" },
    ],
  },
  {
    title: "Personnes & garanties",
    fields: [
      { name: "nb_personnes", label: "Nombre de personnes à assurer", type: "select", required: true, options: [
        { value: "1", label: "1" }, { value: "2", label: "2" }, { value: "3", label: "3" }, { value: "4", label: "4 et +" } ] },
      { name: "date_naissance", label: "Date de naissance de l'assuré principal", type: "date", required: true },
      { name: "garanties", label: "Garanties recherchées", type: "checkboxes", options: [
        { value: "hospitalisation", label: "Hospitalisation" }, { value: "soins_courants", label: "Soins courants" },
        { value: "optique", label: "Optique" }, { value: "dentaire", label: "Dentaire" },
        { value: "maternite", label: "Maternité" }, { value: "assistance", label: "Rapatriement sanitaire" } ] },
      { name: "niveau_couverture", label: "Niveau de garanties souhaité", type: "level", required: true },
    ],
  },
  {
    title: "CFE & budget",
    description: "La Caisse des Français de l'Étranger (CFE) peut être complétée par une assurance privée.",
    fields: [
      { name: "cfe", label: "Êtes-vous (ou serez-vous) affilié à la CFE ?", type: "radio", required: true, options: [
        { value: "oui", label: "Oui" }, { value: "non", label: "Non" }, { value: "ne_sais_pas", label: "Je ne sais pas" } ] },
      { name: "type_couverture", label: "Type de couverture souhaitée", type: "radio", required: true, options: [
        { value: "premier_euro", label: "Au premier euro (couverture complète)" }, { value: "complement_cfe", label: "En complément de la CFE" } ] },
      { name: "budget", label: "Budget mensuel indicatif", type: "slider", min: 30, max: 800, step: 10, default: 150, unit: " €" },
      { name: "priorite", label: "Votre priorité", type: "radio", required: true, options: [
        { value: "prix", label: "Le prix" }, { value: "garanties", label: "Les garanties" }, { value: "equilibre", label: "L'équilibre" } ] },
    ],
  },
];

export default function SimulateurExpat() {
  return <SimulatorWizard simType="expatrie" title="Parcours B — Assurance santé expatrié" subtitle="Comparez les assurances expatrié" steps={steps} />;
}
